import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ChatPage } from './ChatPage';
import { useChatHandoffIntake } from '../hooks/useChatHandoffIntake';

/**
 * Arche wrapper for Chat — provides ArcheLayout with sidebar
 * and handles sub-routing for channel selection.
 */
export function ChatArchePage() {
  // Handoffs (`open_channel`) land here, above the per-route ChatPage.
  useChatHandoffIntake();
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/channel/:channelId" element={<ChatPage />} />
      </Routes>
    </ArcheLayout>
  );
}
